<template>
    <div class="controls">
        <a
            v-if="showPreviousBtn"
            class="prev-btn"
            @click="previousStep"
        >Back</a>
        <base-submit-button
            class="btn"
            :loading="$wait.is('onboardingProcessing')"
            @click="nextOnboardingStep"
        >
            <slot name="button">
                Save and Continue
            </slot>
        </base-submit-button>
        <a
            v-if="showSkipBtn"
            class="skip-btn"
            @click="skipOnboarding"
        >
            <slot name="skip-text">
                Skip this step.
            </slot>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        showPreviousBtn: {
            type: Boolean,
            default: true,
        },

        showSkipBtn: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        /**
         * Emits skip onboarding evet
         *
         */
        skipOnboarding() {
            this.$event.$emit('skipOnboarding');
        },

        /**
         * Emits next onboarding step event
         *
         */
        nextOnboardingStep() {
            this.$event.$emit('onboardingNextStep');
        },

        /**
         * Emits previuous onboarding step event
         *
         */
        previousStep() {
            this.$event.$emit('onboardingPreviousStep');
        },
    },
};
</script>
